import React from "react";
import PropTypes from "prop-types";
import { Navbar, NavbarBrand } from "shards-react";


const SidebarMainNavbar = ()=> {

    // const { hideLogoText } = this.props;
    return (
      <div className="main-navbar">
        <Navbar
          className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0"
          type="light"
        >
          <NavbarBrand
            className="w-100 mr-0"
            href="/medias"
            style={{ lineHeight: "25px" }}
          >
            <div className="d-table mr-auto">
              <img
                id="main-logo"
                className="d-inline-block align-top ml-4"
                // style={{ maxWidth: "25px" }}
                src={require("../../../images/icon-logo.svg")}
                alt="UseB.관리자"
              />
            </div>
          </NavbarBrand>
          {/* eslint-disable-next-line */}
          <a
            className="toggle-sidebar d-sm-inline d-md-none d-lg-none"
            // onClick={this.handleToggleSidebar}
          >
            <i className="material-icons">close</i>
          </a>
        </Navbar>
      </div>
    );
  }


SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false
};

export default SidebarMainNavbar;
